<template>
    <v-container class="main-container">
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">操作ログ</v-col>
            </v-row>
        </v-container>
        <v-row class="my-2 ml-4" no-gutters>
            <v-col xl="2" lg="2" md="3" sm="12" xs="12" class="pa-0">
                <badge-component tile color="unset">
                    <label-component height="25" style="font-size: 12px">日付</label-component>
                </badge-component>
                <usage-log-date-picker-component v-model="searchItem.from_date" :defaultDate="searchItem.from_date"></usage-log-date-picker-component>
            </v-col>
            <div class="align-self-end pa-2">～</div>
            <v-col xl="2" lg="2" md="3" sm="12" xs="12" class="align-self-end pa-0">
                <usage-log-date-picker-component v-model="searchItem.to_date" :defaultDate="searchItem.to_date"></usage-log-date-picker-component>
            </v-col>
        </v-row>
        <v-row class="my-2 ml-4" no-gutters>
            <v-col xl="2" md="2" sm="12" xs="12" class="py-0 pr-2">
                <badge-component tile color="unset">
                    <label-component height="15" style="font-size: 12px">ユーザー名</label-component>
                </badge-component>
                <v-text-field
                  v-model="searchItem.user_name" 
                  clearable
                  outlined
                  dense
                  hide-details
                  background-color="white"
                  class="search-text-field"
                ></v-text-field>
            </v-col>
            <v-col xl="4" md="4" sm="12" xs="12" class="py-0 pr-2">
                <badge-component tile color="unset">
                    <label-component height="15" style="font-size: 12px">画面</label-component>
                </badge-component>
                <v-combobox
                    v-model="searchItem.display_name"
                    :items="displayNameList"
                    hide-selected
                    clearable
                    multiple
                    outlined
                    persistent-hint
                    background-color="white"
                    small-chips
                    hide-details
                    class="search-text-select"
                ></v-combobox>
            </v-col>
            <v-col xl="3" md="3" sm="12" xs="12" class="py-0 pr-2">
                <badge-component tile color="unset">
                    <label-component height="15" style="font-size: 12px">操作</label-component>
                </badge-component>
               <v-combobox
                    v-model="searchItem.operation"
                    :items="operationList"
                    hide-selected
                    clearable
                    multiple
                    outlined
                    hide-details
                    persistent-hint
                    background-color="white"
                    small-chips
                    class="search-text-select"
                ></v-combobox>
            </v-col>
            <v-col xl="2" md="2" sm="12" xs="12" class="py-0 pr-2">
                <badge-component tile color="unset">
                    <label-component height="15" style="font-size: 12px">対象</label-component>
                </badge-component>
                <v-text-field
                    v-model="searchItem.target"
                    outlined
                    clearable
                    hide-details
                    background-color="white"
                    dense
                    class="search-text-field"
                ></v-text-field>
            </v-col>
            <v-col xl="1" md="1" sm="12" xs="12" class="align-self-end text-right pt-2 pb-0">
                <v-btn color="blue" style="height: 35px !important" class="white--text search-btn" @click="search">
                    検索
                </v-btn>
            </v-col>
        </v-row>
        <v-row class="pa-0" v-if="items.length > 0">
            <v-col xl="8" lg="8" md="8" sm="6" xs="12" class="align-self-end" offset-xl="2" offset-lg="2" offset-md="1" offset-sm="0" offset-xs="0">
                <v-pagination
                    v-model="indexInfo.page"
                    :length="indexInfo.pageCount"
                ></v-pagination>
            </v-col>
            <v-col xl="2" lg="2" md="3" sm="6" xs="12" class="text-right pr-2">
                <VueJsonToCsv :json-data="csvData" :csv-title="csvTitle" :labels="labels">
                    <v-btn @click="exportFiles" color="orange" class="white--text csv-btn">CSVエクスポート</v-btn>
                </VueJsonToCsv>
            </v-col>
        </v-row>
        <v-data-table
            loading-text="読込中"
            :headers="headers"
            :items="items"
            :page.sync="indexInfo.page"
            :items-per-page="indexInfo.itemsPerPage"
            @page-count="indexInfo.pageCount = $event"
            hide-default-footer
        >
            <template v-slot:body="props">
                <tbody>
                    <tr v-for="(item, index) in props.items">
                        <td class="white-space-nowrap" align="left">{{ item.log_datetime | datetimeFormat}}</td>
                        <td class="white-space-nowrap" align="left">{{ item.user_name }}</td>
                        <td class="white-space-nowrap" align="left">{{ item.display_name }}</td>
                        <td class="white-space-nowrap" align="left">{{ item.operation }}</td>
                        <td class="white-space-nowrap" align="left">{{ item.target }}</td>
                        <td class="white-space-nowrap" align="left">{{ item.supplement }}</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
    import moment from 'moment';
    import VueJsonToCsv from "vue-json-to-csv";
    import DatePickerComponent from "./DatePickerComponent";
    export default {
        props: {
            logs: Array,
            from_date: String,
            to_date: String,
        },
        data() {
            return {
                items: [],
                searchItem: {
                    from_date: "",
                    to_date: "",
                    user_name: "",
                    display_name: [],
                    operation: [],
                    target: "",
                },
                indexInfo: {
                    page: 1, // ページ数
                    pageCount: 0, // 最大ページ数
                    itemsPerPage: 100, // 1ページあたりの項目数
                },
                csvData: [],
                labels: {
                    log_datetime: { title: "日時" },
                    user_name: { title: "ユーザー_氏名" },
                    user_email: { title: "ユーザー_メールアドレス" },
                    display_name: { title: "画面" },
                    operation: { title: "操作" },
                    target_id: { title: "対象ID" },
                    target: { title: "対象" },
                    supplement: { title: "補足" },
                },
                headers: [
                    { text: "日時", value: "log_datetime", align: "left", width: "13%", sortable: false},
                    { text: "ユーザー", value: "user_name", align: "left", width: "8%", sortable: false},
                    { text: "画面", value: "display_name", align: "left", width: "22%", sortable: false},
                    { text: "操作", value: "operation", align: "left", width: "15%", sortable: false},
                    { text: "対象", value: "target", align: "left", sortable: false},
                    { text: "補足", value: "supplement", align: "left", sortable: false},
                ],
                displayNameList : [
                    'DX-Sign本登録',
                    'メンバー招待',
                    'ログイン',
                    'パスワード再設定',
                    'ログアウト',
                    '新規書類の送信',
                    '新規書類の送信 - 1.契約書・書類の選択',
                    '新規書類の送信 - 2.書類のタイトル入力',
                    '新規書類の送信 - 3.送付先の入力',
                    '新規書類の送信 - 4.書類の入力項目を設定',
                    '新規書類の送信 - 5.送付内容確認',
                    '新規書類の送信 - テンプレート選択',
                    '新規書類の送信 - 一括送信',
                    '契約概要',
                    '契約概要プレビュー',
                    '契約情報詳細',
                    '文書管理',
                    'ユーザ定義の書類情報の編集',
                    '書類インポート',
                    'テンプレート管理',
                    'テンプレート作成 - 1.契約書・書類の選択',
                    'テンプレート作成 - 2.書類のタイトル入力',
                    'テンプレート作成 - 4.書類の入力項目を選択',
                    'テンプレート概要',
                    'テンプレートプレビュー',
                    '利用プラン変更',
                    '企業情報更新',
                    '支払方法更新',
                    '契約先企業一覧',
                    '契約先メンバー一覧',
                    'グループ一覧',
                    'グループメンバー一覧',
                    'メンバー一覧',
                    '個人用印影一覧',
                    '企業用印影一覧',
                    'ご利用料金の確認',
                    '書類の確認',
                    'アクセス制限',
                    'タイムスタンプ一括検証',
                ],
                operationList:[
                    'DX-Sign本登録',
                    'メンバー招待の承諾',
                    'ログイン',
                    'パスワード再設定',
                    'ログアウト',
                    '書類の新規作成',
                    '書類の追加',
                    '書類の削除',
                    '書類の送信',
                    '書類の検索',
                    '書類の下書き保存',
                    '書類のダウンロード',
                    '書類のプレビュー',
                    '書類の移動',
                    '書類の承認',
                    '書類の確認',
                    '書類の転送',
                    '書類の却下',
                    '書類の一括送信',
                    '合意締結証明書ダウンロード',
                    'テンプレート概要表示',
                    'テンプレート選択',
                    '下書き書類の破棄',
                    'リマインド',
                    '契約情報詳細表示',
                    '契約情報保存',
                    '上の階層に戻る',
                    'すべての書類表示',
                    'キャビネット表示',
                    'キャビネット名変更',
                    'キャビネット削除',
                    'キャビネットから書類の削除',
                    'キャビネットグループの編集',
                    'キャビネット共有登録',
                    'キャビネット共有削除',
                    'キャビネット作成',
                    'フォルダ作成',
                    'フォルダ表示',
                    'フォルダの移動',
                    'フォルダ名変更',
                    'フォルダ削除',
                    '契約概要表示',
                    'アラート削除',
                    'アラート設定',
                    'インポート書類の削除',
                    'ユーザ定義項目保存',
                    '書類のインポート',
                    'テンプレート削除',
                    'テンプレート新規作成',
                    'テンプレート編集終了',
                    'テンプレート概要表示',
                    'テンプレートプレビュー',
                    'テンプレートダウンロード',
                    '利用プラン変更の申し込み',
                    '企業情報保存',
                    '企業情報更新画面表示',
                    '支払方法更新画面表示',
                    '支払方法保存',
                    '契約先企業一覧画面表示',
                    '契約先企業エクスポート',
                    '契約先企業インポート',
                    '契約先企業検索',
                    '契約先企業削除',
                    '契約先企業追加',
                    '契約先企業情報保存',
                    '契約先メンバー一覧画面表示',
                    '契約先メンバーエクスポート',
                    '契約先メンバーインポート',
                    '契約先メンバー検索',
                    '契約先メンバー削除',
                    '契約先メンバー追加',
                    '契約先メンバー保存',
                    'グループ一覧画面表示',
                    'グループ削除',
                    'グループ追加',
                    'グループ情報保存',
                    'グループメンバー削除',
                    'グループメンバー追加',
                    'グループメンバー情報保存',
                    'メンバー一覧画面表示',
                    'メンバー検索',
                    'メンバー削除',
                    'メンバー招待リマインド',
                    'メンバー招待取消',
                    'メンバー招待',
                    'メンバー情報保存',
                    '個人用印影一覧画面表示',
                    '個人用印影削除',
                    '個人用印影登録',
                    '企業用印影一覧画面表示',
                    '企業用印影削除',
                    '企業用印影登録',
                    'ご利用料金の確認画面表示',
                    'アクセス制限の設定画面表示',
                    'IPアドレス登録',
                    'IPアドレス削除',
                    'タイムスタンプ一括検証画面表示',
                    'タイムスタンプ一括検証実行',
                ],
           };
        },
        created : function() {
            this.items = this.logs;
            this.searchItem.from_date = this.from_date;
            this.searchItem.to_date = this.to_date;
        },
        computed: {
            csvTitle: function() {
                return "dxsign_log";
            },
        },
        filters: {
            datetimeFormat(date) {
                return moment(date).format('YYYY/MM/DD HH:mm:ss');
            },
        },
        methods: {
            search: async function() {
                await window.axios
                    .post('usage-logs/search', {
                        'from_date': this.searchItem.from_date?? "",
                        'to_date': this.searchItem.to_date?? "",
                        'user_name': this.searchItem.user_name?? "",
                        'display_name': this.searchItem.display_name?? "",
                        'operation': this.searchItem.operation?? "",
                        'target': this.searchItem.target?? "",
                    })
                    .then(function (response) {
                        if (response.data.success) {
                            this.items = response.data.logs;
                        } else {
                            this.items = [];
                        }
                    }.bind(this))
                    .catch(function (response) {
                        console.log(response);
                    }
                );
            },
            exportFiles() {
                let regExp = /"/g;
                this.csvData = [];
                this.items.forEach((data) => {
                    this.csvData.push({
                        "log_datetime": moment(data.log_datetime).format('YYYY/MM/DD HH:mm:ss')?? "",
                        "user_name": data.user_name.replace(regExp, '""')?? "",
                        "user_email": data.user_email?? "",
                        "display_name": data.display_name?? "",
                        "operation": data.operation?? "",
                        "target_id": data.target_id?? "",
                        "target": data.target? data.target.replace(regExp, '""') : "",
                        "supplement": data.supplement? data.supplement.replace(regExp, '""') : "",
                    });
                });
            },
        },
        components: {
            VueJsonToCsv,
            'usage-log-date-picker-component': DatePickerComponent
        },
    };
</script>

<style scoped lang="scss">
    ::v-deep .csv-btn.v-btn {
        height: 36px !important;
    }
    
    ::v-deep .search-btn > .v-btn__content {
        font-size: 1.5rem !important;
    }
    
    ::v-deep .csv-btn > .v-btn__content {
        font-size: 1.5rem !important;
    }
    
    ::v-deep .search-text-select .search-text-field {
        min-width: 165px !important;
    }
    
    .search-text-field ::v-deep input {
        font-size: 1.5rem !important;
    }
    
    .search-text-field ::v-deep .v-input__slot {
        height: 36px !important;
        min-height: 30px !important;
    }
    
    .search-text-select ::v-deep .v-input__icon {
        height: 30px !important;
    }
    
    .search-text-select ::v-deep .v-chip.v-size--small {
        border-radius: 8px;
        font-size: 9px;
        height: 16px;
    }
    
    .search-text-select ::v-deep .v-input__slot{
        min-height: 36px !important;
    }
    
    .search-text-select ::v-deep .v-input__append-inner{
        margin-top: 4px;
    }
    
    .search-text-select ::v-deep input{
        font-size: 1.5rem !important;
    }
    
    ::v-deep .v-list-item__content{
        padding: 0px !important;
    }
    
    ::v-deep .v-list-item__title {
        font-size: 1.5rem !important;
    }
    
    .v-select.v-input--dense .v-chip {
        margin: 5px !important;
    }
    
    .white-space-nowrap {
        max-width: 0px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    
    .v-data-table ::v-deep > .v-data-table__wrapper > table > tbody > tr > td,
    .v-data-table ::v-deep > .v-data-table__wrapper > table > thead > tr > th {
        font-size: 12px !important;
        padding: 0px 6px!important;
        height: 30px;
    }
    
    .v-data-table ::v-deep > .v-data-table__wrapper > table > tbody > tr:hover {
        background-color: transparent !important;
    }
</style>